module.exports = __webpack_public_path__ + "../resources/img/member_img0.3851fea2.png";